import type { AdminRole } from 'bundles/enterprise-admin-management/types';

export const MENTOR_TEMPLATE_ID = '4_S33UQOEe2SkwokLYGt7Q';
export const STAFF_TEMPLATE_ID = '-JNxDxX6TqiTcQ8V-i6oLg';
export const ORG_ADMIN_TEMPLATE_ID = 'ZA6l2YsCRTKOpdmLArUyfQ';
export const PROGRAM_ADMIN_TEMPLATE_ID = 'bgbUOSTZS12G1Dkk2Utd0Q';
export const RECRUITER_TEMPLATE_ID = 'fG9wV2wGSkOvcFdsBgpDyQ';

export const TEMPLATE_ID: { [role in AdminRole]: string } = {
  ORG_ADMIN: ORG_ADMIN_TEMPLATE_ID,
  PROGRAM_ADMIN: PROGRAM_ADMIN_TEMPLATE_ID,
  MENTOR: MENTOR_TEMPLATE_ID,
  PII_RESTRICTED_ADMIN: STAFF_TEMPLATE_ID,
  RECRUITER: RECRUITER_TEMPLATE_ID,
};

export const ADMIN_ROLE_FROM_TEMPLATE_ID: { [id: string]: AdminRole } = {
  [ORG_ADMIN_TEMPLATE_ID]: 'ORG_ADMIN',
  [PROGRAM_ADMIN_TEMPLATE_ID]: 'PROGRAM_ADMIN',
  [MENTOR_TEMPLATE_ID]: 'MENTOR',
  [STAFF_TEMPLATE_ID]: 'PII_RESTRICTED_ADMIN',
  [RECRUITER_TEMPLATE_ID]: 'RECRUITER',
};
